import styled from 'styled-components';
import { AppStoreLink } from '../app-links/AppStoreLink';
import { PlayStoreLink } from '../app-links/PlayStoreLink';

export const AppDownloads = () => (
  <View>
    <PlayStoreLink height={40} />
    <AppStoreLink height={40} />
  </View>
);

const View = styled.div`
  display: flex;
  flex-direction: row;
  gap: 16px;
`;
